<a
  appLogoClick
  [routerLink]="contextService.homeRedirectRoute$ | async"
>
  <div *ngIf="whiteLabelService.shopId$ | async as shopId; else defaultLogo">
    <img [appImgSrc]="shopId | appShopLogoUrl" [class]="isSmall ? 'h-30px w-60px' : 'h-40px w-80px'" />
  </div>
  <ng-template #defaultLogo>
    <div
      class="logo__image-wrapper h-25px w-120px"
      [ngClass]="isSmall ? 'logo__image-wrapper--small w-35px' : ''"
    ></div>
  </ng-template>
</a>
